import React, { useState, useCallback } from "react"
import { Drawer } from "antd"
import { ProjectForm } from "~/components"
import * as dayjs from "dayjs"

const useProject = ({
  project,
  loading = false,
  width = "60%",
  onClose,
  onSubmit,
  onRemove,
} = {}) => {
  const [visible, setVisible] = useState(false)
  const show = () => setVisible(true)
  const hide = () => setVisible(false)
  const onCancel = () => {
    onClose && onClose()
    hide()
  }

  const ProjectDrawer = useCallback(() => {
    return (
      <Drawer
        width={width}
        closeIcon={null}
        keyboard={false}
        title={"Project"}
        open={visible}
        onClose={onCancel}
      >
        <ProjectForm
          id={project?.id}
          initialValues={{
            ...project,
            ...(project?.startDate &&
              project?.endDate && {
                rangeTime: [dayjs(project?.startDate), dayjs(project?.endDate)],
              }),
          }}
          onSubmit={onSubmit}
          onRemove={onRemove}
          onCancel={onCancel}
          loading={loading}
        />
      </Drawer>
    )
    // eslint-disable-next-line
  }, [visible])

  return {
    visible,
    show,
    hide,
    ProjectDrawer,
  }
}

export default useProject
